import React from "react";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <div className={`reveal ${className}`} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}

export function SectionLabel({ children }) {
  return (
    <span className="text-xs font-semibold uppercase tracking-[0.25em] gold-text">{children}</span>
  );
}

export function Container({ children, className = "" }) {
  return <div className={`max-w-7xl mx-auto px-4 sm:px-8 ${className}`}>{children}</div>;
}
